import React, { Component } from 'react';
import { Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';

Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});



const rounds = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Angel', 'Seed', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series undisclosed']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Number of events'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Rounds raised',
        data: [25, 148, 48, 23, 7, 3, 2, 1, 1, 55]
    }]
}


const rounds2 = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['$0-2M', '$2-5M','$5-10M','$10-20M','$20-50M','$50M+',]
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Number of events'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Rounds raised',
        data: [168, 38, 22, 12, 9, 9]
    }]
}

const capital = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Angel', 'Seed', 'Series A', 'Series B', 'Series C', 'Series D', 'Series E', 'Series F', 'Series G', 'Series undisclosed']
    },
    yAxis: {
        min: 0,
        title: {
            text: 'Amount invested ($M USD)'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Rounds raised',
        data: [8, 132, 292, 446, 369, 97, 562, 1100, 2000, 1427]
    }]
}







export class ChapterFortyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

                <TextHolder text="While the availability of funding in SEA has generally improved in the last few years, large gaps still exist, according to AJ Azizuddin, director at Mountain Partners Malaysia. 'Series A are pretty well covered, but there is still a gap in Series B-C, for VCs—there is lots of work to be done' he said." />

                <TextHolder text="Michael Lints, partner at Golden Gate Ventures, agreed that there was a late-stage funding gap. 'The impact is that companies get acquired too early,' he said." />

                <TextHolder text="Lints added that he thought it would be three or more years before the region saw a large flow of exits, especially from its growing herd of unicorns. “Just look at global data—it takes seven to eight years before a company is able to create real shareholder value,” he said." />

                <TextHolder text="" />

        

                <Highchartscomponent className="topic-text-color"   chartsText="Number of rounds raised by stage (2017)" options={rounds} notes="Notes: Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia" source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>} />

                <Highchartscomponent   chartsText="Number of deals by round size (2017)" options={rounds2} notes="Notes: Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia" source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>}/>

                <Highchartscomponent   chartsText="Total capital invested by funding stage (2017)" options={capital} notes="Notes: Countries represented: Singapore, Malaysia, Thailand, Philippines, Vietnam, Indonesia" source={<p>Source: <a href="https://www.crunchbase.com">Crunchbase</a>, Slush Singapore analysis</p>} />


                <div className="block-outer block-outer-tableholder">
                  <div className="block-inner block-inner-tableholder">
                    <table id="t01">
                    <tbody>
                      <tr>
                        <td>Round</td>
                        <td>Angel</td>
                        <td>Seed</td>
                        <td>Series A</td>
                        <td>Series B</td>
                        <td>Series C</td>
                        <td>Series D</td>
                        <td>Series E</td>
                        <td>Series F</td>
                        <td>Series G</td>
                        <td>Series undisclosed</td>
                      </tr>
                      <tr>
                        <td># Deals</td>
                        <td>25</td>
                        <td>148</td>
                        <td>48</td>
                        <td>23</td>
                        <td>7</td>
                        <td>3</td>
                        <td>2</td>
                        <td>1</td>
                        <td>1</td>
                        <td>55</td>
                      </tr>
                      <tr>
                        <td>Average</td>
                        <td>$326K</td>
                        <td>$894K</td>
                        <td>$6.1M</td>
                        <td>$19M</td>
                        <td>$53M</td>
                        <td>$32M</td>
                        <td>$281M</td>
                        <td>$1.1B</td>
                        <td>$2B</td>
                        <td>$26M</td>
                      </tr>

                      </tbody>
                    </table>
                </div>
                </div>


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/41.js